import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { SceneStore } from '../../stores/SceneStore';
import { VisibilityStore } from '../../stores/VisibilityStore';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { PopupMenu, SidebarModule } from '../../constants/Enums';
import { CameraHelper } from '../../utils/CameraHelper';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { SelectBoxActions } from '../../actions/SelectBoxActions';
import { PopupFlagPosition } from '../../constants/PopupFlagPositions';
import { SelectBoxStore } from '../../stores/SelectBoxStore';
import { CoreTooltip } from '../CoreTooltip';
import { BasePopupMenu } from './BasePopupMenu';

interface CameraSelectProps {
    layoutType: LayoutType;
}

interface CameraSelectState {
    view: any;
    open: boolean;
}

export class CameraSelect extends BaseComponent<CameraSelectProps, CameraSelectState> {
    public componentWillMount(): void {
        this.addStoreListener(SceneStore, this.onChange);
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.view) {
            if (this.props.layoutType === LayoutType.SMALL) {
                return (
                    <div
                        className={this.getCameraSelectCSSClass()}
                        onClick={SelectBoxActions.showCameraSelection}
                    />
                );
            }
            return (
                <BasePopupMenu
                    defaultValue={this.state.view.cameraControl.cameraMode}
                    flagPosition={PopupFlagPosition.TOPLEFT}
                    open={this.state.open}
                    toggleCallback={this.toggleSelect}
                    changeCallback={this.cameraChange}
                    className={this.getCameraSelectCSSClass()}
                    options={SelectBoxStore.getCameraOptions()}
                    title={{label: t('View'), className: ''}}
                >
                    {this.state.open ? null : <CoreTooltip config={{label: t('View')}}/>}
                </BasePopupMenu>
            );
        }
        return null;
    }

    protected onChange = (): void => {
        this.setState({
            view: SceneStore.getState().activeView ? GlobalHelper.coreApp.viewer.activeView : null,
            open: VisibilityStore.getState().popupMenu === PopupMenu.CAMERA
        });
    };

    private cameraChange = (pValue: string) => {
        CameraHelper.setCameraMode(parseInt(pValue, 10));
        VisibilityActions.hidePopupMenu(PopupMenu.CAMERA);
    };

    private toggleSelect = (pValue: boolean) => {
        if (!pValue) {
            ViewSettingsActions.changeSidebar(SidebarModule.NONE);
            VisibilityActions.setPopupMenu(PopupMenu.CAMERA);
        } else {
            VisibilityActions.hidePopupMenu(PopupMenu.CAMERA);
        }
    };

    private getCameraSelectCSSClass = (): string => {
        let tSelectBoxClass: string = 'toolbar-button toolbar-camera toolbar-button-popup';
        switch (this.state.view.cameraControl.cameraMode) {
            case 1:
                tSelectBoxClass += ' toolbar-cam-bottom';
                break;
            case 2:
                tSelectBoxClass += ' toolbar-cam-left';
                break;
            case 3:
                tSelectBoxClass += ' toolbar-cam-right';
                break;
            case 4:
                tSelectBoxClass += ' toolbar-cam-front';
                break;
            case 5:
                tSelectBoxClass += ' toolbar-cam-back';
                break;
            case 6:
                tSelectBoxClass += ' toolbar-cam-ortho';
                break;
            case 7:
                tSelectBoxClass += ' toolbar-cam-pers';
                break;
            default:
                tSelectBoxClass += ' toolbar-cam-top';
                break;
        }
        return tSelectBoxClass;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/CameraSelect.tsx